import React, { useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

// Importe ícones do Lucide se necessário
import { Clock } from 'lucide-react';

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  // Obter o título da página com base na rota atual
  const getPageTitle = () => {
    switch (location.pathname) {
      case '/':
        return 'Dashboard';
      case '/financas':
        return 'Controle Financeiro';
      case '/trafego-marketing':
        return 'Tráfego Pago';
      case '/colaboradores':
        return 'Colaboradores';
      case '/produtos':
        return 'Produtos';
      case '/usuarios':
        return 'Gerenciamento de Usuários';
      default:
        // Tenta pegar um título genérico ou baseado no path
        const pathParts = location.pathname.split('/').filter(Boolean);
        if (pathParts.length > 0) {
           const title = pathParts[pathParts.length - 1];
           return title.charAt(0).toUpperCase() + title.slice(1).replace('-', ' ');
        }
        return 'App Financeiro'; // Fallback
    }
  };

  // Alternar o estado da sidebar
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className={`flex h-screen overflow-hidden bg-gray-50 ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      {/* Sidebar com animação de transição */}
      <Sidebar collapsed={sidebarCollapsed} />

      {/* Área principal de conteúdo */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Header fixo */}
        <Header
          pageTitle={getPageTitle()}
          onToggleSidebar={toggleSidebar}
          sidebarCollapsed={sidebarCollapsed}
        />

        {/* Conteúdo principal com scroll */}
        <main className="flex-1 overflow-y-auto relative">
          <div className="container mx-auto px-4 py-6">
            <Outlet />
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 py-4 px-6">
          <div className="flex items-center justify-between">
            <p className="text-sm text-gray-600">
              &copy; {new Date().getFullYear()} App de Controle Financeiro
            </p>
            <div className="flex items-center text-sm text-gray-500">
              <Clock className="h-4 w-4 mr-2" />
              <span>{new Date().toLocaleTimeString('pt-BR', { timeZone: 'America/Sao_Paulo' })}</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Layout;
